<template>
	<div>
		<ja-global-rules
			:data="expenseCategoryData"
			@globalRulesData="handleData"
		></ja-global-rules>
		<ja-scripts-form
			:data="expenseCategoryData"
			@scriptsData="handleData"
		></ja-scripts-form>
		<ja-research-scripts-form
			:data="expenseCategoryData"
			@researchAddScripts="handleData"
		></ja-research-scripts-form>
		<ja-shopping-form
			:data="expenseCategoryData"
			@shoppingData="handleData"
		></ja-shopping-form>
		<div class="container-buttons">
			<ja-button
				name="save"
				class="small outlined"
				@click.native="saveExpenseCategory"
				>{{ $t('save') }}</ja-button
			>
			<ja-button name="cancel" class="small" @click.native="cancel">{{
				$t('cancel')
			}}</ja-button>
		</div>
	</div>
</template>
<script>
import Button from '@/components/ui/Button';
import GlobalRules from './GlobalRules.vue';
import ScriptsForm from './ScriptsForm.vue';
import ResearchScriptsForm from './ResearchScriptsForm.vue';
import ShoppingForm from './ShoppingForm.vue';
import { ResizeImage } from '@/mixins';

export default {
	components: {
		jaGlobalRules: GlobalRules,
		jaScriptsForm: ScriptsForm,
		jaShoppingForm: ShoppingForm,
		jaResearchScriptsForm: ResearchScriptsForm,
		jaButton: Button
	},
	mixins: [ResizeImage],
	props: {
		expenseCategoryData: {
			type: Object,
			required: true
		}
	},
	data() {
		return {};
	},
	mounted() {},
	methods: {
		handleData(newData) {
			this.expenseCategoryData = newData;
		},
		dataURLtoFile(dataurl, filename) {
			const arr = dataurl.split(',');
			const mime = arr[0].match(/:(.*?);/)[1];
			const bstr = atob(arr[arr.length - 1]);
			let n = bstr.length;
			let u8arr = new Uint8Array(n);
			while (n--) {
				u8arr[n] = bstr.charCodeAt(n);
			}
			return new File([u8arr], filename, { type: mime });
		},
		async readFileAsync(file) {
			return new Promise((resolve, reject) => {
				const reader = new FileReader();
				reader.onload = () => {
					resolve(reader.result);
				};
				reader.onerror = reject;
				reader.readAsDataURL(file);
			});
		},
		async saveExpenseCategory() {
			if (this.expenseCategoryData) {
				if (this.expenseCategoryData.cmsExpenseSubCategories) {
					const maxLogoWidth = 226;
					const maxLogoHeight = 226;

					for (
						let i = 0;
						i < this.expenseCategoryData.cmsExpenseSubCategories.length;
						i++
					) {
						const item = this.expenseCategoryData.cmsExpenseSubCategories[i];

						if (item && item.imageBase64) {
							if (item.imageBase64.split(',').length > 1) {
								const original = this.dataURLtoFile(item.imageBase64, 'image');
								const resizeFile = await this.resizeImage(
									original,
									maxLogoWidth,
									maxLogoHeight
								);
								item.imageBase64 = await this.readFileAsync(resizeFile);
							}
						}
						delete item.lifeStages;
					}
				}

				if (this.expenseCategoryData.cmsExpenseCategoryResearches) {
					const maxLogoWidth = 250;
					const maxLogoHeight = 250;

					for (
						let i = 0;
						i < this.expenseCategoryData.cmsExpenseCategoryResearches.length;
						i++
					) {
						const item = this.expenseCategoryData.cmsExpenseCategoryResearches[
							i
						];
						if (item && item.imageBase64) {
							if (item.imageBase64.split(',').length > 1) {
								const original = this.dataURLtoFile(item.imageBase64, 'image');
								const resizeFile = await this.resizeImage(
									original,
									maxLogoWidth,
									maxLogoHeight
								);
								item.imageBase64 = await this.readFileAsync(resizeFile);
							}
						}
					}
				}

				if (this.expenseCategoryData.cmsExpenseCategoryLogos) {
					const maxLogoWidth = 165;
					const maxLogoHeight = 66;

					for (
						let i = 0;
						i < this.expenseCategoryData.cmsExpenseCategoryLogos.length;
						i++
					) {
						const item = this.expenseCategoryData.cmsExpenseCategoryLogos[i];
						if (item && item.imageBase64) {
							if (item.imageBase64.split(',').length > 1) {
								const original = this.dataURLtoFile(item.imageBase64, 'image');
								const resizeFile = await this.resizeImage(
									original,
									maxLogoWidth,
									maxLogoHeight
								);
								item.imageBase64 = await this.readFileAsync(resizeFile);
							}
						}
					}
				}

				if (this.expenseCategoryData.billboardLogoBase64) {
					const maxLogoWidth = 165;
					const maxLogoHeight = 66;
					if (
						this.expenseCategoryData.billboardLogoBase64.split(',').length > 1
					) {
						const original = this.dataURLtoFile(
							this.expenseCategoryData.billboardLogoBase64,
							'image'
						);
						const resizeFile = await this.resizeImage(
							original,
							maxLogoWidth,
							maxLogoHeight
						);
						this.expenseCategoryData.billboardLogoBase644 = await this.readFileAsync(
							resizeFile
						);
					}
				}
			}

			this.$emit('saveExpenseCategory', this.expenseCategoryData);
		},
		cancel() {
			this.$emit('cancel');
		}
	}
};
</script>
<style lang="scss" scoped>
.container-buttons {
	display: flex;
	align-items: center;
	gap: 20px;
	margin-top: 20px;
	justify-content: flex-end;
}
</style>
